<main>
  <div class="container my-5">
    <h1 class="page-title mb-5">Veel gestelde vragen</h1>
    <div class="row faq-questions">
        <div class="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
          <div class="panel panel-default" *ngFor="let question of questions; index as i">
            <div class="panel-heading" role="tab" id="flush-heading-{{ i }}">
              <h4 class="panel-title">
                <a class="collapsed" role="button" data-bs-toggle="collapse" data-bs-parent="#accordion"  [attr.data-bs-target]="'#flush-collapse-' + i" aria-expanded="true" [attr.aria-controls]="'flush-collapse-' + i">
                  {{ question.question }}
                </a>
              </h4>
            </div>
            <div id="flush-collapse-{{ i }}" class="panel-collapse collapse in" role="tabpanel" [attr.aria-labelledby]="'flush-heading-' + i">
              <div class="panel-body">
                <p>{{ question.answer }}</p>
              </div>
            </div>
          </div>
        </div>
    </div>
  </div>
</main>
